import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from "chart.js";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import { Color, Label } from "ng2-charts";

@Component({
  selector: 'app-chart-pie',
  templateUrl: './chart-pie.component.html',
  styleUrls: ['./chart-pie.component.scss']
})
export class ChartPieComponent implements OnInit {
  @Input() charstData: any;

  public barChartLabels2: Label[] = [];
  public barChartType2: ChartType = "pie";
  public barChartLegend2 = true;
  public barChartPlugins2 = [pluginDataLabels];

  public barChartData2: ChartDataSets[] = [
    {
      data: [],
      label: "",
      pointBackgroundColor: ["#00AA8D"],
    }
  ];

  barChartColors2: Color[] = [
    {
      borderColor: "GRAY",
      backgroundColor: ["#28a745", "#1CB0D3", "#ffc107"],
      hoverBackgroundColor: ["#00AA8D", "#00AA8D", "#00AA8D"],
    },
  ];

  public barChartOptions2: ChartOptions = {
    responsive: true,
    plugins: {
      datalabels: {
        color: "transparent",
        anchor: "end",
        align: "left",
        font: {
          size: 12
        }
      }
    }
  }

  ngOnInit() {
    console.log(this.charstData)
    this.showcharts();
  }

  showcharts() {

    this.charstData.forEach(element => {
      this.barChartLabels2.push(element.MEJOR_GESTION + ' ' + 'Clientes:' + element.CLIENTES);
      console.log(element.VALOR, 'elemento original');
      if (element.VALOR) {     element.VALOR = parseInt(element.VALOR.replace(/,/g, ''));   }
      console.log(element.VALOR, 'elemento numérico');
      (this.barChartData2[0].data as number[]).push(element.VALOR);
    });
  }
}



